import { JsonRpcProvider } from 'ethers';

class Provider {
  private state: Record<string, JsonRpcProvider> = {};

  get(url: string) {
    if (this.state[url]) {
      return this.state[url];
    }

    const provider = new JsonRpcProvider(url);
    this.state[url] = provider;
    return provider;
  }
}

export const sharedProvider = new Provider();
